(function () {
  var script =
    document.currentScript || document.querySelector('script[data-recaptcha-site-key]');
  var siteKey = script && script.dataset.recaptchaSiteKey;
  if (!siteKey) return;

  var API_SRC = 'https://www.google.com/recaptcha/api.js?render=' + encodeURIComponent(siteKey);
  var ACTION = 'newsletter_signup';
  var FORM_SELECTOR = 'form.newsletter-form';
  // If reCAPTCHA is unreachable (blocked network, outage), submit anyway after this delay
  var EXECUTE_TIMEOUT_MS = 4000;

  var apiPromise = null;

  function loadApi() {
    if (apiPromise) return apiPromise;
    apiPromise = new Promise(function (resolve, reject) {
      var tag = document.createElement('script');
      tag.src = API_SRC;
      tag.async = true;
      tag.onload = function () {
        if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
          window.grecaptcha.ready(function () {
            resolve(window.grecaptcha);
          });
        } else {
          reject(new Error('grecaptcha unavailable'));
        }
      };
      tag.onerror = function () {
        reject(new Error('reCAPTCHA script failed to load'));
      };
      document.head.appendChild(tag);
    });
    return apiPromise;
  }

  // Warm up once the visitor interacts with a signup field, so the token is
  // usually ready by the time they submit and the initial page load stays light.
  document.addEventListener('focusin', function (event) {
    if (event.target.closest && event.target.closest(FORM_SELECTOR)) {
      loadApi().catch(function () {});
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches(FORM_SELECTOR)) return;
    if (form.dataset.recaptchaDone === 'true') return;

    event.preventDefault();

    var finished = false;
    function proceed() {
      if (finished) return;
      finished = true;
      form.dataset.recaptchaDone = 'true';
      // Resubmit in a fresh task: if the token resolves instantly (cached),
      // a synchronous requestSubmit would still be inside the original submit
      // dispatch and get dropped by the browser's re-entrancy guard.
      setTimeout(function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }, 0);
    }

    setTimeout(proceed, EXECUTE_TIMEOUT_MS);

    // The token is intentionally NOT attached to the form: Shopify's /contact
    // endpoint reserves the g-recaptcha-response parameter for its own retired
    // challenge flow and rejects any submission carrying it with
    // "reCAPTCHA v2 is no longer supported". Executing without attaching still
    // gates submission on running Google's JS and records scores in the
    // reCAPTCHA admin console.
    loadApi()
      .then(function (grecaptcha) {
        return grecaptcha.execute(siteKey, { action: ACTION });
      })
      .then(function () {
        proceed();
      })
      .catch(proceed);
  });
})();
